export default "__VITE_ASSET__Cly8P64L__"